var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 26c7.18 0 13-5.82 13-13S20.18 0 13 0 0 5.82 0 13s5.82 13 13 13z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.601 12.17V9.684a3.604 3.604 0 00-4.98-3.33 3.601 3.601 0 00-2.223 3.33v2.488a1.873 1.873 0 00-1.789 1.87v5.878h10.78V14.04a1.873 1.873 0 00-1.788-1.87zM13 7.35a2.336 2.336 0 012.333 2.333v2.484h-4.667V9.683A2.336 2.336 0 0113 7.35z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.97 15.073a.97.97 0 10-1.515.801v2.106h1.09v-2.106a.968.968 0 00.424-.8z",
    fill: "#E95832"
  })));
}
export default __webpack_public_path__ + "static/media/lock.8a384750.svg";
export { SvgLock as ReactComponent };